import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Ticket Detail
export const createTicketDetail = createAsyncThunk(
  'ticketDetail/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/ticket-details', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ticket detail');
    }
  }
);

// Fetch Ticket Detail by ID
export const fetchTicketDetailById = createAsyncThunk(
  'ticketDetail/fetchById',
  async (ticketDetailId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/ticket-details/${ticketDetailId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket detail');
    }
  }
);

// Fetch All Ticket Details
export const fetchAllTicketDetails = createAsyncThunk(
  'ticketDetail/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/ticket-details');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket details');
    }
  }
);

// Update Ticket Detail
export const updateTicketDetail = createAsyncThunk(
  'ticketDetail/update',
  async ({ ticketDetailId, ...data }: any & { ticketDetailId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/ticket-details/${ticketDetailId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ticket detail');
    }
  }
);

// Delete Ticket Detail
export const deleteTicketDetail = createAsyncThunk(
  'ticketDetail/delete',
  async (ticketDetailId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/ticket-details/${ticketDetailId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ticket detail');
    }
  }
);

// Create Comment or Reply
export const createCommentOrReply = createAsyncThunk(
  'ticketDetail/createCommentOrReply',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/ticket-details/comment-or-reply', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create comment or reply');
    }
  }
);

// Fetch Ticket Details with Replies
export const fetchTicketDetailsWithReplies = createAsyncThunk(
  'ticketDetail/fetchWithReplies',
  async (ticketId: string, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/ticket-details/replies/${ticketId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket details with replies');
    }
  }
);

// Update Ticket Assignee
export const updateTicketAssignee = createAsyncThunk(
  'ticketDetail/updateAssignee',
  async ({ ticketId, assignedTo, modifiedBy }: { ticketId: any; assignedTo: number; modifiedBy: number },
    { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/ticket-detail/${ticketId}/assignee`, {
        assignedTo,
        modifiedBy,
      });
      return {ticketId,assignedTo};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update assignee');
    }
  },
  
);

// Update Ticket Priority By Ticket ID
export const updateTicketPriority = createAsyncThunk(
  'ticketDetail/updatePriorityByTicketId',
  async (
    { ticketId, priority }: { ticketId: any; priority: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.put('/ticket-details/update/priority', {
        ticketId,
        priority,
      });
      return { ticketId, priority };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ticket priority');
    }
  }
);

